import startCase from 'lodash/startCase';

import { readableSingularSegmentType, segmentTypes } from '~/lib/segments';

export function destinationNameForType(destinationType) {
  switch (destinationType) {
    case destinationTypeCustomHtml:
      return 'Custom HTML';
    case destinationTypeEmail:
      return 'Email digest';
    default:
      return startCase(destinationType);
  }
}

export function shortDescriptionForType(destinationType) {
  switch (destinationType) {
    case destinationTypeEmail:
      return 'Send matches via scheduled emails';
    case destinationTypeSalesforce:
      return 'Post to Chatter or create new Tasks';
    case destinationTypeSlack:
      return 'Send messages to Slack channels';
    case destinationTypeWebhook:
      return 'Post new matches to webhook URLs';
    case destinationTypeCustomHtml:
      return 'Trigger HTML/JS on segment match';
    case destinationTypeFacebookConversion:
      return 'Send new matches as a Facebook conversion event';
    case destinationTypeGoogleConversion:
      return 'Send new matches as a Google Adwords conversion event';
    default:
      return startCase(destinationType);
  }
}

export function destinationSubtitleForType(
  destinationType,
  typename,
  includeLink = true,
) {
  const segmentType = readableSingularSegmentType(typename);

  switch (destinationType) {
    case destinationTypeWebhook:
      return (
        <span>
          Post to a URL of your choice when a {segmentType} matches the segment.{' '}
          {includeLink && (
            <a
              href="https://help.clearbit.com/hc/en-us/articles/360022031574-Webhook-Destination"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}>
              Learn more
            </a>
          )}
        </span>
      );
    case destinationTypeEmail:
      return (
        <span>
          Send a scheduled email with a CSV digest of{' '}
          {segmentType === 'person' ? 'people' : 'companies'} matching the
          segment.{' '}
          {includeLink && (
            <a
              href="https://help.clearbit.com/hc/en-us/articles/360022232093-Email-Destination"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}>
              Learn more
            </a>
          )}
        </span>
      );
    case destinationTypeSlack:
      return (
        <span>
          Post to Slack when a {segmentType} matches the segment.{' '}
          {includeLink && (
            <a
              href="https://help.clearbit.com/hc/en-us/articles/360022030174-Slack-Destination"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}>
              Learn more
            </a>
          )}
        </span>
      );
    case destinationTypeSalesforce:
      return (
        <span>
          Create a Salesforce Task or post to Chatter when a {segmentType}{' '}
          matches the segment.{' '}
          {includeLink && (
            <a
              href="https://help.clearbit.com/hc/en-us/articles/360022031134-Salesforce-Destination"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}>
              Learn more
            </a>
          )}
        </span>
      );

    case destinationTypeCustomHtml:
      return (
        <span>
          Execute custom HTML/JS on your website when a visitor matches a
          segment.{' '}
          {includeLink && (
            <a
              href="https://help.clearbit.com/hc/en-us/articles/360036261373-Custom-HTML-Destination-beta-"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}>
              Learn more
            </a>
          )}
        </span>
      );

    case destinationTypeFacebookConversion:
      return (
        <span>
          Send an event to Facebook when a {segmentType} matches the segment.{' '}
          {includeLink && (
            <a
              href="https://help.clearbit.com/hc/en-us/articles/..."
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}>
              Learn more
            </a>
          )}
        </span>
      );

    case destinationTypeGoogleConversion:
      return (
        <span>
          Send an event to Google Adwords when a {segmentType} matches the
          segment.{' '}
          {includeLink && (
            <a
              href="https://help.clearbit.com/hc/en-us/articles/..."
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}>
              Learn more
            </a>
          )}
        </span>
      );
    default:
  }
}

export function alertDestinationTypes(user, segment) {
  let types = [
    destinationTypeEmail,
    destinationTypeSlack,
    destinationTypeSalesforce,
    destinationTypeWebhook,
  ];

  if (
    segment.type == segmentTypes.person &&
    user.hasFlag('x_quality_ads_conversions')
  ) {
    types.push(destinationTypeFacebookConversion);
    types.push(destinationTypeGoogleConversion);
  }

  return types;
}

export function personalizationDestinationTypes(_user, _segment) {
  return [destinationTypeCustomHtml];
}

export const destinationTypeCustomHtml = 'custom_html';
export const destinationTypeEmail = 'email';
export const destinationTypeSalesforce = 'salesforce';
export const destinationTypeSlack = 'slack';
export const destinationTypeWebhook = 'webhook';
export const destinationTypeFacebookConversion = 'facebook_conversion';
export const destinationTypeGoogleConversion = 'google_conversion';

export const destinationTypes = [
  destinationTypeCustomHtml,
  destinationTypeEmail,
  destinationTypeFacebookConversion,
  destinationTypeGoogleConversion,
  destinationTypeSalesforce,
  destinationTypeSlack,
  destinationTypeWebhook,
];
